import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import { jsx as _jsx } from "react/jsx-runtime";
const EventRefinementView = ({
  flow
}) => {
  const enrollmentCriteria = flow.enrollmentCriteria;
  const refinementCriteria = !enrollmentCriteria || enrollmentCriteria.triggerType !== 'EVENT' ? undefined : enrollmentCriteria.refinementCriteria;
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "refinement-criteria-action-card",
    children: /*#__PURE__*/_jsx(ListSegmentationFilters, {
      value: refinementCriteria,
      readOnly: true,
      objectTypeId: flow.objectTypeId
    })
  });
};
export default EventRefinementView;